// import { FaFacebook } from 'react-icons/fa';
export const links = [
  {
    id: 1,
    url: '/',
    text: 'start',
  },
  {
    id: 2,
    url: '/info',
    text: 'informacje',
  },
  // {
  //   id: 3,
  //   url: '/reservations',
  //   text: 'rezerwacje',
  // },
  // {
  //   id: 5,
  //   url: '/my-profile',
  //   text: 'moje dane ',
  //   requiresAuth: true,
  //
  // },
  // {
  //   id: 6,
  //   url: '/camera',
  //   text: 'kamera ',
  // },
  // {
  //   id: 7,
  //   url: '/register',
  //   text: 'rejestracja',
  //   requiresNotAuth: true,
  // },
  // {
  //   id: 8,
  //   url: '',
  //   text: 'Wyloguj',
  //   requiresAuth: true,
  //   requiresNotAuth: false,
  // }
];

export const social = [
  // {
  //   id: 1,
  //   url: 'https://www.facebook.com/groups/261960086358911',
  //   icon: <FaFacebook />,
  // },
  // {
  //   id: 2,
  //  url: 'https://www.twitter.com',
  //   icon: <FaTwitter />,
  // },
  // {
  //   id: 3,
  //   url: 'https://www.twitter.com',
  //   icon: <FaLinkedin />,
  // },
];
